import React from 'react';

import { TranslationList } from '../components/Translations';

const PageAdministrationTranslationList = () => (
  <TranslationList />
);

export default PageAdministrationTranslationList;
